import { debounce } from '@utils/functions';
import Swiper, { A11y, Autoplay, EffectFade, Keyboard, Navigation, Pagination } from 'swiper';
import BaseComponent from '../base/baseComponent';
Swiper.use([Pagination, Autoplay, A11y, EffectFade, Keyboard, Navigation]);
export default class PerfumeProductHighlightComponent extends BaseComponent {
    constructor(element) {
        super(element);
        let imagesLoaded = setInterval(() => {
            if (document.readyState === 'complete') {
                clearInterval(imagesLoaded);
                this.init();
            }
        }, 100);
    }
    init() {
        this.slides = this.$el.querySelectorAll('.swiper-slide');
        if (this.slides.length > 1) {
            this.initSlider();
        }
    }
    initCustomClasses(swiper, afterInit) {
        if (afterInit) {
            let stateCheck = setInterval(() => {
                clearInterval(stateCheck);
                this.$el.querySelectorAll('img:not(.lazyloaded)').forEach((el) => el.classList.add('lazyload'));
                this.$el.classList.add('initialized');
                swiper.autoplay.start();
            }, 100);
        }
        const slides = this.$el.querySelectorAll('.perfume-product-highlight-slide');
        slides.forEach((slide) => {
            slide.classList.remove('swiper-slide--custom-active');
        });
        const slidedActive = this.$el.querySelector('.swiper-slide-active');
        if (slidedActive) {
            setTimeout(() => {
                slidedActive.classList.add('swiper-slide--custom-active');
            }, 10);
        }
    }
    onSlideActive(swiper) {
        swiper.slides.forEach((element, index) => {
            if (index === swiper.activeIndex) {
                element.querySelectorAll('a').forEach(function (link) {
                    link.setAttribute('tabIndex', '0');
                });
            }
            else {
                element.querySelectorAll('a').forEach(function (link) {
                    link.setAttribute('tabIndex', '-1');
                });
            }
        });
    }
    beforeResize() {
        this.carousel.autoplay.running && this.carousel.autoplay.stop();
        this.$el.classList.add('resizing');
    }
    onResize(swiper) {
        this.$el.classList.remove('resizing');
        this.paginationChange(swiper);
        !this.carousel.autoplay.running && this.carousel.autoplay.start();
    }
    paginationChange(swiper) {
        const imageCaption = this.slides[swiper.realIndex].querySelector('.perfume-product-highlight-slide__caption');
        const textColumn = this.slides[swiper.realIndex].querySelector('.perfume-product-highlight-slide__text-column');
        const newTop = ((imageCaption.offsetTop + 20) / 10).toString();
        const newLeft = ((textColumn.offsetLeft + textColumn.offsetWidth / 2) / 10).toString();
        this.$el.querySelector('.swiper-pagination--bars').style.setProperty('--top', `${newTop}rem`);
        this.$el.querySelector('.swiper-pagination--bars').style.setProperty('--left', `${newLeft}rem`);
    }
    initSlider() {
        this.carousel = new Swiper(this.$el, {
            slidesPerView: 1,
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: this.$options.prevslidemessage,
                nextSlideMessage: this.$options.nextslidemessage,
                firstSlideMessage: this.$options.firstslidemessage,
                lastSlideMessage: this.$options.lastslidemessage,
                paginationBulletMessage: this.$options.paginationbulletmessage.replace('INDEX_NUMBER', '{{index}}'),
            },
            on: {
                beforeResize: () => this.beforeResize(),
                resize: debounce((swiper) => this.onResize(swiper), 500),
                afterInit: (swiper) => this.initCustomClasses(swiper, true),
                beforeTransitionStart: () => this.initCustomClasses(),
                activeIndexChange: (swiper) => this.onSlideActive(swiper),
                slideChange: (swiper) => {
                    this.paginationChange(swiper);
                },
            },
        });
    }
}
